<template>
  <div>
    <b-card-header
      style="margin-top: -25px;"
    >
      <b-row class="match-height">
        <b-col
          v-if="!$route.query.token"
          lg="12"
          md="12"
          sm="12"
        >
          <Card-Menu-Top />
        </b-col>
        <b-col
          lg="12"
          md="12"
          sm="12"
        >
          <Card-Map />
        </b-col>
        <b-col
          v-if="userData.username !== 'drr-center'"
          lg="12"
          md="12"
          sm="12"
        >
          <Card-Counting-Bar />
        </b-col>
        <b-col
          v-if="userData.username !== 'drr-center'"
          lg="6"
          md="6"
          sm="12"
        >
          <div>
            <top-5-traffic-routes />
          </div>
        </b-col>
        <b-col
          v-if="userData.username !== 'drr-center'"
          lg="6"
          md="6"
          sm="12"
        >
          <div>
            <weekly-accident-analytics />
          </div>
        </b-col>
        <b-col
          v-if="userData.username !== 'drr-center'"
          lg="6"
          md="6"
          sm="6"
        >
          <div>
            <vehicle-proportion />
          </div>
        </b-col>
        <b-col
          v-if="userData.username !== 'drr-center'"
          lg="6"
          md="6"
          sm="6"
        >
          <div>
            <traffic-volume />
          </div>
        </b-col>
        <b-col
          v-if="userData.username !== 'drr-center'"
          lg="6"
          md="6"
          sm="12"
        >
          <div>
            <CCTVDisplay />
          </div>
        </b-col>
        <b-col
          v-if="userData.username !== 'drr-center'"
          lg="6"
          md="6"
          sm="12"
        >
          <div>
            <TopCCTVLocations />
          </div>
        </b-col>
      </b-row>
      <Card-VMS
        v-if="userData.username !== 'drr-center'"
        class="mt-1"
      />
      <Card-Traffic
        v-if="userData.username !== 'drr-center'"
        class="mt-1"
      />
    </b-card-header>
  </div>
</template>

<script>
import {
  BCardHeader, BRow, BCol,
} from 'bootstrap-vue'
import CardMenuTop from '@/views/dashboard/CardMenuTopDB.vue'
import CardMap from '@/views/dashboard/CardMapDB.vue'
import CardCountingBar from '@/views/dashboard/CardCountingBarDB.vue'
import CardVMS from '@/views/dashboard/CardVMSDB.vue'
import CardTraffic from '@/views/dashboard/CardTrafficDB.vue'
import Top5TrafficRoutes from '@/views/dashboard/Top5TrafficRoutes.vue'
import WeeklyAccidentAnalytics from '@/views/dashboard/WeeklyAccidentAnalytics.vue'
import VehicleProportion from '@/views/dashboard/VehicleProportion.vue'
import TrafficVolume from '@/views/dashboard/TrafficVolume.vue'
import CCTVDisplay from '@/views/dashboard/CCTVDisplay.vue'
import TopCCTVLocations from '@/views/dashboard/TopCCTVLocations.vue'

export default {
  components: {
    BRow,
    BCol,
    CardMenuTop,
    CardMap,
    CardCountingBar,
    CardVMS,
    CardTraffic,
    BCardHeader,
    Top5TrafficRoutes,
    WeeklyAccidentAnalytics,
    VehicleProportion,
    TrafficVolume,
    CCTVDisplay,
    TopCCTVLocations,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  created() {
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';

// Combined styles for match-height and dashboard-cards
.match-height.dashboard-cards {
  display: flex;
  flex-wrap: wrap;
  margin: -0.25rem; // Reduced negative margin

  > [class*="col"] {
    padding: 0.25rem; // Reduced padding
    display: flex;
  }
}

// Chart container styles
:deep(.chart-container) {
  height: 100%;
  min-height: 250px;
}

// Original text styles
.text1, .text2 {
  position: absolute;
  font-family: Arial;
  top: 20px;
  right: 20px;
  color: white;
}

// Utility classes for spacing
.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}
</style>
